document.querySelectorAll('.pc-form').forEach(form => {
	const action = form.getAttribute('action')
	const method = form.getAttribute('method')
	form.addEventListener('submit', async e => {
		e.preventDefault()
		const statusOutput = form.querySelector('.status')
		const body = new FormData(form)
		const res = await fetch(action, {
			method,
			headers: {
				Accept: 'application/json',
			},
			body,
		})
		const { success } = await res.json()
		if (success) {
			const submitButton = form.querySelector('input[type=submit]')
			submitButton.disabled = true
			statusOutput.value =
				'Thank you for your message! We will be in touch soon.'
		} else {
			statusOutput.value =
				'Sorry, there was a problem sending your message. Please try again, or contact us at corregenerate@gmail.com.'
		}
	})
})
